import {Button} from "react-bootstrap";
import {IconContext} from "react-icons";
import PropTypes, {number} from "prop-types";
import HasButtonRole from "./authirization/HasButtonRole.jsx";


const ButtonWithIcon = (props) => {

    const styles = {
        btn: {
            lineHeight: '1',
            paddingTop: `${props.size !== 'sm' ? '5px' : '3px'}`,
            paddingBottom: `${props.size !== 'sm' ? '5px' : '4px'}`,
            paddingLeft: `${props.size !== 'sm' ? '7px' : '4px'}`,
            paddingRight: `${props.size !== 'sm' ? '7px' : '4px'}`,
        },
        icon: {
            marginRight: '1px',
            display: 'inline-block',
            transform: `${props.size !== 'sm' ? `translateY(${props.text ? '-1px' : '0px'})` : null}`
        },
        text: {
            display: 'inline-block',
            transform: `${props.size === 'sm' ? 'translateY(2px)' : null}`,
            paddingRight: `${props.text ? '3px' : null}`,
            paddingLeft: `${props.text ? '3px' : null}`

        }
    }

    return <HasButtonRole roles={props.roles?.[0] || ['any']} mode={props.roles?.[1] || 'pass'}>
        <Button
            className={props.className}
            size={props.size}
            data-testid={props.dataTestId}
            disabled={props.disabled}
            style={styles.btn}
            variant={props.variant}
            title={props.title || props?.text?.toLowerCase()}
            onClick={props.onClick}>
            <IconContext.Provider
                value={{size: props.iconSize || 22}}>
                <div
                    style={styles.icon}> {props.icon}</div>
            </IconContext.Provider>
            <div style={styles.text}> {props.text}</div>

        </Button>
    </HasButtonRole>

}

ButtonWithIcon.propTypes = {
    icon: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    size: PropTypes.oneOf(['lg', 'sm']),
    variant: PropTypes.string,
    title: PropTypes.string,
    iconSize: PropTypes.oneOfType([PropTypes.string, number]),
    text: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    roles: PropTypes.array,
};

export default ButtonWithIcon